import React, { useState, useEffect } from "react";
import "./ContactForm.css";
import countries from "./countries";
import states from "./states";
import cities from "./cities";
import { Helmet } from "react-helmet-async";
import axios from "axios";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    company: "",
    Websiteurl: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [availableStates, setAvailableStates] = useState([]);
  const [availableCities, setAvailableCities] = useState([]);

  useEffect(() => {
    if (formData.country) {
      const countryStates = states.filter(
        (state) => state.country === formData.country
      );
      setAvailableStates(countryStates);
      setFormData((prev) => ({ ...prev, state: "", city: "" }));
      setAvailableCities([]);
    } else {
      setAvailableStates([]);
      setAvailableCities([]);
    }
  }, [formData.country]);

  useEffect(() => {
    if (formData.state) {
      const stateCities = cities.filter(
        (city) => city.state === formData.state
      );
      setAvailableCities(stateCities);
    }
  }, [formData.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.mobile.trim()) newErrors.mobile = "Mobile number is required";
    else if (!/^\d{10}$/.test(formData.mobile))
      newErrors.mobile = "Invalid mobile number";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Invalid email address";
    if (!formData.country) newErrors.country = "Country is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.pincode) newErrors.pincode = "Pincode is required";
    else if (!/^\d{6}$/.test(formData.pincode))
      newErrors.pincode = "Invalid pincode";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const response = await axios.post(
        "https://justseo.in/contact-us/api/sendemailcontact", 
        formData
      );
      console.log("Email sent:", response.data);

      setShowSuccess(true);
      setFormData({
        name: "",
        mobile: "",
        email: "",
        company: "",
        Websiteurl: "",
        country: "",
        state: "",
        city: "",
        pincode: "",
        message: "",
      });

      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
    } catch (error) {
      console.error("Error sending email:", error);
      alert("Failed to send message.");
    }
  };

  return (
    <div className="contact-container">
          <Helmet>
          <title>Contact Us Just SEO – India’s Trusted SEO & Digital Marketing Experts</title>
       <meta name="description" content="Ready to grow your business online? Get in touch with Just SEO’s expert team for custom SEO and digital marketing solutions tailored to your goals."/>
            <meta
              name="keywords"
              content="AI SEO, artificial intelligence SEO, machine learning SEO, ChatGPT for SEO, AI content optimization, Google Bard SEO, NLP for SEO, AI keyword research, automated SEO, predictive SEO, AI backlink analysis, SEO automation tools, AI-powered rankings, generative AI SEO, AI meta descriptions, SEO machine learning,AI SEO tools, ChatGPT SEO prompts, Google Gemini SEO, multilingual AI SEO, AI content detection, AI for technical SEO, AI-powered backlinks, AI SERP analysis, AI for featured snippets, AI SEO audits, AI for local SEO, AI eCommerce SEO, AI video SEO, AI for voice search, AI content scoring, SEO machine learning models, neural matching optimization, AI for zero-click SEO, SEO services, digital marketing agency, search engine optimization, on-page SEO, off-page SEO, local SEO, eCommerce SEO, Google ranking, SEO expert, PPC advertising, social media marketing, content marketing, email marketing, YouTube SEO, voice search SEO, AI SEO, backlink building, keyword research, technical SEO, mobile SEO, Shopify SEO, WordPress SEO, SEO audit, Google Ads, Facebook Ads, LinkedIn marketing, SEO consultant, affordable SEO services, SEO for small business,content marketing, email marketing, influencer marketing, affiliate marketing, Google Ads, Facebook Ads, best SEO strategies 2024, how to improve Google ranking, SEO for small businesses, e-commerce SEO tips, voice search optimization, AI in digital marketing, Meta ads management, YouTube SEO techniques, mobile SEO best practices, SEO vs SEM,Search engine optimization,SEO services,SEO agency,SEO consultant,SEO expert,SEO company,SEO audit,SEO tools,Google ranking,Organic search traffic,Backlink building,Broken link building,Digital PR for SEO,Page speed optimization,SEO near me,Voice search optimization,Mobile-first indexing,Global SEO strategy,Multiregional SEO,How to improve SEO ranking, Real estate lead generation, Healthcare marketing,How to get backlinks naturally,Google Search Console,Google Analytics 4 (GA4),Rank tracking,Click-through rate (CTR),Bounce rate SEO,Dwell time,Organic impressions,Search query reports,Cannibalization tracking,SEO KPI dashboard,AI tools for digital marketing,AI tools for digital marketing"
            />
            <meta property="og:title" content="Contact Us Just SEO – India’s Trusted SEO & Digital Marketing Experts" />
            <meta
              property="og:image"
              content="https://justseo.in/faviconcopy.png"
            />
             <meta property="og:title" content="Contact Us Just SEO – India’s Trusted SEO & Digital Marketing Experts" />
            <meta property="og:url" content="https://justseo.in/contact-us" />
            <meta name="robots" content="index, follow" />
          
          </Helmet>
          {showSuccess && (
            <div className="popup-success">
              <p>Form submitted. Now let’s make search engines love you!</p>
            </div>
          )}
      {/* Contact Side Panel */}
      <div className="contact-side-panel">
        <h2>Hate Filling out Forms?</h2>

        <div className="contact-method">
          <h3>Request a Quote</h3>
          <a href="mailto:digital@justseo.in">digital@justseo.in</a>
        </div>

        <div className="contact-method">
          <h3>For Reseller Partner</h3>
          <a href="mailto:info@justseo.in">info@justseo.in</a>
        </div>

        <div className="contact-method">
          <h3>HR Queries</h3>
          <p>
            Email: <a href="mailto:hr@justseo.in">hr@justseo.in</a>
          </p>
          <p>
            Call: <a href="tel:+919155599968">+91 9155599968</a>
          </p>
        </div>

        <div className="contact-method">
          <h3>Call</h3>
          <a href="tel:+912269710459">+91 2269710459</a>
        </div>

        <div className="contact-method">
          <h3>Whatsapp</h3>
          <a href="https://wa.me/912269710459">+91 2269710459</a>
        </div>
      </div>

      {/* Contact Form */}
      <div className="js-contact-form-wrapper">
        <div className="js-form-content">
          <h2 className="js-form-main-title">Contact Us</h2>
          <p className="js-form-secondary-title">We'd love to hear from you</p>

          
          <form onSubmit={sendEmail} className="js-contact-form">
            <div className="form-two-column-layout">
              {/* Left Column */}
              <div className="form-left-column">
                <div className="js-form-field-group">
                  <label htmlFor="name">Name*</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className={errors.name ? "js-input-error-state" : ""}
                  />
                  {errors.name && (
                    <span className="js-error-text">{errors.name}</span>
                  )}
                </div>

                <div className="js-form-field-group">
                  <label htmlFor="mobile">Mobile Number*</label>
                  <input
                    type="text"
                    id="mobile"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    className={errors.mobile ? "js-input-error-state" : ""}
                  />
                  {errors.mobile && (
                    <span className="js-error-text">{errors.mobile}</span>
                  )}
                </div>

                <div className="js-form-field-group">
                  <label htmlFor="email">Email ID*</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={errors.email ? "js-input-error-state" : ""}
                  />
                  {errors.email && (
                    <span className="js-error-text">{errors.email}</span>
                  )}
                </div>

                <div className="js-form-field-group">
                  <label htmlFor="company">Company Name</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                  />
                </div>

                <div className="js-form-field-group">
                  <label htmlFor="Websiteurl">Website Url</label>
                  <input
                    type="text"
                    id="Websiteurl"
                    name="Websiteurl"
                    placeholder="www.justseo.in"
                    value={formData.Websiteurl}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Right Column */}
              <div className="form-right-column">
                <div className="js-form-field-group">
                  <label htmlFor="country">Country*</label>
                  <select
                    id="country"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    className={errors.country ? "js-input-error-state" : ""}
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country.code} value={country.name}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                  {errors.country && (
                    <span className="js-error-text">{errors.country}</span>
                  )}
                </div>

                <div className="js-form-field-group">
                  <label htmlFor="state">State*</label>
                  <select
                    id="state"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    disabled={!formData.country}
                    className={errors.state ? "js-input-error-state" : ""}
                  >
                    <option value="">Select State</option>
                    {availableStates.map((state) => (
                      <option key={state.code} value={state.name}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                  {errors.state && (
                    <span className="js-error-text">{errors.state}</span>
                  )}
                </div>

                <div className="js-form-field-group">
                  <label htmlFor="city">City*</label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    disabled={!formData.state}
                    className={errors.city ? "js-input-error-state" : ""}
                  />
                  {errors.city && (
                    <span className="js-error-text">{errors.city}</span>
                  )}
                </div>

                <div className="js-form-field-group">
                  <label htmlFor="pincode">Pin Code*</label>
                  <input
                    type="text"
                    id="pincode"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                    className={errors.pincode ? "js-input-error-state" : ""}
                  />
                  {errors.pincode && (
                    <span className="js-error-text">{errors.pincode}</span>
                  )}
                </div>

                <div className="js-form-field-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                  />
                </div>
              </div>
            </div>

            <button type="submit" className="js-form-submit-button">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
